export default __webpack_public_path__ + "static/media/tag-icon-beginner.d8102715.svg";